import React from 'react'

const IconTag = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M3 3h8l10 10-8 8L3 11V3Z' />
         <circle cx='8' cy='8' r='1.3' fill='currentColor' stroke='none' />
      </svg>
   )
}
export default IconTag
